import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../lib/cn.ts'

export const avatarVariants = cva(
  cn(
    'inline-flex items-center justify-center shrink-0 rounded-full font-semibold',
    'select-none text-background',
  ),
  {
    variants: {
      size: {
        xs: 'h-5 w-5 text-[9px]',
        sm: 'h-6 w-6 text-[10px]',
        md: 'h-8 w-8 text-xs',
        lg: 'h-10 w-10 text-sm',
      },
    },
    defaultVariants: { size: 'sm' },
  },
)

export type AvatarVariants = VariantProps<typeof avatarVariants>

/**
 * Deterministic colour palette for `seed`-based avatars. Matches the mock manager
 * colours in `apps/console/src/shared/mocks/managers.ts` so avatars rendered from
 * managers without an explicit `color` field stay visually consistent.
 */
export const AVATAR_PALETTE = [
  '#6366f1', // indigo
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ec4899', // pink
  '#06b6d4', // cyan
] as const

export function seedToColor(seed: string): string {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0
  }
  const idx = Math.abs(hash) % AVATAR_PALETTE.length
  return AVATAR_PALETTE[idx]
}
